import { render, staticRenderFns } from "./BillOfLadingQrView.vue?vue&type=template&id=5f548f68&scoped=true&"
import script from "./BillOfLadingQrView.vue?vue&type=script&lang=js&"
export * from "./BillOfLadingQrView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f548f68",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
